import { UserFriendlyError } from "../../../../../common/utils/base_error";
import { FileUtils } from "../../../../../common/utils/file_utils";
import { ICreateObraUseCase } from "../../../presentation/useCases/create/create_obra_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateObraUseCase
 */

export class CreateObraUseCase implements ICreateObraUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async createObra(
    tipo: number,
    idFuncionarioAprovado: number | null,
    idFuncionarioRevisado: number | null,
    idCentroCusto: number | null,
    idEmpreendimento: number | null,
    historicoRevisoes: string | null,
    apresentacaoObra: string | null,
    processo: string | null,
    pctPdeFadDatec: string | null,
    meios: string | null,
    estOrgFileUpload: File | null,
    cantFileUpload: File | null,
  ): Promise<number> {
    if (tipo === 1) throw new UserFriendlyError('Uma obra não pode ser criada com status finalizado!');

    const extEo = estOrgFileUpload ? estOrgFileUpload.name.substring(estOrgFileUpload.name.lastIndexOf('.') + 1) : null;
    const extCo = cantFileUpload ? cantFileUpload.name.substring(cantFileUpload.name.lastIndexOf('.') + 1) : null;

    const estOrgFile = await FileUtils.readFileAsBase64(estOrgFileUpload);
    const cantFile = await FileUtils.readFileAsBase64(cantFileUpload);

    return await this.repository.createObra(
      tipo,
      idFuncionarioAprovado,
      idFuncionarioRevisado,
      idCentroCusto,
      idEmpreendimento,
      historicoRevisoes,
      apresentacaoObra,
      processo,
      pctPdeFadDatec,
      meios,
      estOrgFile,
      cantFile,
      extEo,
      extCo,
    );
  }
}
